import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createContactInquiryService } from '../../api/contactApi';

export const createContactInquiry = createAsyncThunk('contact/createContactInquiry', async (data) => {
    const response = await createContactInquiryService(data);
    return response.data;
});


const contactSlice = createSlice({
    name: 'contact',
    initialState: {
        contactForm: {
            name: "", email: "", mobile_no: null, message: ""
        },
        status: null,
        msg: '',
        contactInquiryLoader: false,
        contact: []
    },
    reducers: {
        clearFormData: (state, action) => {
            // // console.log({ action });
            state.contactForm = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createContactInquiry.pending, (state) => {
                state.contactInquiryLoader = true;
                state.status = false;
            })
            .addCase(createContactInquiry.fulfilled, (state, action) => {
                state.contactInquiryLoader = false;
                state.contact = action.payload;
                state.status = true;
            })
            .addCase(createContactInquiry.rejected, (state, action) => {
                state.contactInquiryLoader = false;
                state.contact = action.payload;
                state.status = null;
            })
    },
});

export const { clearFormData } = contactSlice.actions;

export default contactSlice.reducer;

